import React, { useState } from 'react';

import { Box, Paper } from '@mui/material';

import { PopperComponent } from 'components/_basic/Popper/Popper';

import { IDropdownMenuProps } from './types';
import { DropdownMenuItem } from '../DropdownMenuItem';

import styles from './DropdownMenu.module.scss';

export const DropdownMenu: React.FC<IDropdownMenuProps> = ({
  menuItems,
  children,
  stopPropagate = false,
  ...restProps
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const shouldExpandMenu = !!menuItems.length;

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    if (stopPropagate) {
      event.stopPropagation();
    }
    if (shouldExpandMenu) setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => setAnchorEl(null);

  return (
    <>
      {children({ handleMenuOpen, handleMenuClose, isOpen: Boolean(anchorEl) })}

      <PopperComponent
        {...restProps}
        open={Boolean(anchorEl)}
        className={styles.menuWrapper}
        placement={'bottom-start'}
        anchorEl={anchorEl}
        container={anchorEl}
        onClose={handleMenuClose}
      >
        <Paper elevation={0} className={styles.menuOptionsContainer}>
          <Box component="ul" className={styles.listContainer}>
            {menuItems.map(({ label, shouldCloseOnClick = true, icon, onClick }) => (
              <DropdownMenuItem
                key={label}
                label={label}
                icon={icon}
                shouldCloseOnClick={shouldCloseOnClick}
                closeMenu={handleMenuClose}
                onClick={onClick}
              />
            ))}
          </Box>
        </Paper>
      </PopperComponent>
    </>
  );
};
